import React from 'react';

/**
 * StatCard - KPI metric display
 * FLO Design System v2
 */
export const StatCard = ({ value, label, icon: Icon, onClick }) => {
  return (
    <div
      className={`bg-white border border-gray-200 rounded-lg p-2 ${onClick ? 'cursor-pointer hover:border-red-800 transition-colors' : ''}`}
      onClick={onClick}
    >
      {Icon && (
        <div className="mb-1.5">
          <Icon className="w-3.5 h-3.5 text-gray-400" />
        </div>
      )}
      <div className="text-xl font-semibold text-gray-900 leading-none mb-0.5">{value}</div>
      <div className="text-xs text-gray-500 uppercase tracking-wide leading-tight">{label}</div>
    </div>
  );
};

export default StatCard;
